import React, { useState, useContext, useCallback } from 'react'
import { TrackPlayControls } from '../SearchResults/TrackPlayControls'
import { TracksList } from '../SearchResults/TracksList'
import { GlobalMusicContext } from '../../context/GlobalMusicContext'

export const Player = ( props ) => {
  const [toggle, setToggle] = useState( false )
  const [alertMssg, setAertMssg] = useState( false )
  const [{ currentTrack }, dispatch] = useContext( GlobalMusicContext )

  const setCurrentTrack = useCallback( data => {
    dispatch( { type: "setCurrentTrack", snippet: data } )
  },
    [dispatch] )

  const handleUnavailable = () => {
    if ( currentTrack.url === null ) {
      setAertMssg( true )
      history.goBack()
    }
  }
  const onToggleBottomNav = () => {
    if ( window.innerWidth > 500 ) {
      setToggle( !toggle )
    }
  }
  return (
    <div className="players__wrapper">
      <TrackPlayControls
        toggle={toggle}
      />
    </div>
  )
}
